import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubjectMobile } from "../../../Pages/SubjectMobile/ISubjectMobile";

export const DeleteSubjectMobileSlice = createSlice({
  name: "DeleteSubjectMobile",
  initialState: {} as IReduxState<ISubjectMobile>,
  reducers: {
    deleteSubjectMobile: (state, _) => {
      state.isLoading = true;
    },
    successdeleteSubjectMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failuredeleteSubjectMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteSubjectMobileResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteSubjectMobile,
  failuredeleteSubjectMobile,
  successdeleteSubjectMobile,
  clearDeleteSubjectMobileResponse,
} = DeleteSubjectMobileSlice.actions;

export default DeleteSubjectMobileSlice.reducer;
